import React from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { palette } from "../../../theme/palette";
import { getMatrixProfileType } from "../../../reducers/matrixProfile/selectors";
import { DriverIcon } from "../../Icons";
import { View } from "../../Base";
import DriverlessRoutesPopover from "./DriverlessRoutesPopover";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  infoIcon: {
    margin: "0 4px 0 15px",
    fill: palette.typography.white.high,
    cursor: "pointer",
  },
  driverIcon: {
    width: "16px",
    height: "16px",
    color: "black",
  },
  fillOrange: {
    fill: palette.orange,
  },
}));

const DriverlessRoutesComponent = ({ driverlessRoutes }) => {
  const styles = useStyles();
  const planType = useSelector(getMatrixProfileType);
  const [waveAnchorEl, setWarningAnchorEl] = React.useState(null);

  driverlessRoutes = Object.keys(driverlessRoutes).reduce((acc, type) => {
    driverlessRoutes[type].forEach((route) => acc.push({ type, route }));
    return acc;
  }, []);

  return (
    <View className={styles.container}>
      <DriverIcon
        className={clsx(
          styles.infoIcon,
          styles.driverIcon,
          waveAnchorEl ? styles.fillOrange : null
        )}
        onClick={(event) =>
          !!driverlessRoutes?.length && setWarningAnchorEl(event.currentTarget)
        }
      />
      {driverlessRoutes?.length || 0}
      <DriverlessRoutesPopover
        driverlessRoutes={driverlessRoutes}
        planType={planType}
        open={!!waveAnchorEl}
        onClose={() => setWarningAnchorEl(null)}
        anchorEl={waveAnchorEl}
      />
    </View>
  );
};

export default DriverlessRoutesComponent;
